import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2, ArrowRight, Phone, Mail } from "lucide-react";
import { api } from "@/lib/api";
import { fireConversion } from "@/lib/tracking";

export default function ThankYou() {
  const [fired, setFired] = useState(false);

  useEffect(() => {
    document.title = "Thank you · KIKI Centre for Technology";
    api.get("/settings")
      .then(({ data }) => fireConversion(data))
      .catch(() => {})
      .finally(() => setFired(true));
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground flex items-center justify-center px-6 py-16 relative overflow-hidden" data-testid="thankyou-page">
      <div className="absolute inset-0 pointer-events-none opacity-[0.04] [background-image:radial-gradient(hsl(var(--foreground))_1px,transparent_1px)] [background-size:22px_22px]" />
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        className="relative w-full max-w-xl border border-foreground bg-background shadow-[8px_8px_0_0_hsl(var(--foreground))] px-8 md:px-12 py-12 text-center"
        data-hidden-fired={String(fired)}
      >
        <motion.div
          initial={{ scale: 0.5, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.15, type: "spring", stiffness: 200, damping: 15 }}
          className="mx-auto w-16 h-16 grid place-items-center rounded-full bg-[#FFCC00] text-black mb-7"
        >
          <CheckCircle2 className="w-8 h-8" strokeWidth={2} />
        </motion.div>

        <div className="label-overline text-muted-foreground">Enquiry received · Session 2026</div>
        <h1 className="font-sans font-black text-4xl md:text-5xl leading-[1] tracking-tight mt-3">Thank you.</h1>
        <p className="text-muted-foreground mt-4 text-base leading-relaxed">
          Your enquiry has reached the KIKI admissions team. We&rsquo;ll review your details and
          get back to you shortly with the next steps for your programme.
        </p>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3 text-left">
          <div className="border border-border p-4">
            <Phone className="w-4 h-4 mb-2 text-muted-foreground" strokeWidth={1.6} />
            <div className="label-overline text-muted-foreground text-[10px]">Call us</div>
            <a href="tel:+918800288994" className="font-sans font-bold text-sm mt-0.5 hover:text-[#FFCC00] transition-colors block">+91 88002 88994</a>
          </div>
          <div className="border border-border p-4">
            <Mail className="w-4 h-4 mb-2 text-muted-foreground" strokeWidth={1.6} />
            <div className="label-overline text-muted-foreground text-[10px]">Email</div>
            <div className="font-sans font-bold text-sm mt-0.5 break-all">admissions@kikicentre.com</div>
          </div>
        </div>

        <Link
          to="/"
          data-testid="thankyou-home-link"
          className="btn-pill-yellow inline-flex items-center justify-center gap-2 w-full py-3.5 mt-8"
        >
          Back to homepage <ArrowRight className="w-4 h-4" strokeWidth={2} />
        </Link>
      </motion.div>
    </div>
  );
}
